<template>
  <div class='quote'>
    <ul>
      <li>
        <router-link :to='{name: "orderQuoteResources"}'>
          <span>1: 資料撮影</span>
          <Icon icon="chevron-right"/>
        </router-link>
        <router-link :to='{name: "orderQuoteInfoInput"}'>
          <span>2: 見積作成</span>
          <Icon icon="chevron-right"/>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
    export default {
        name: 'quote',
        mounted: function() {
            this.$$.context({
                title: '見積り:'+this.$route.params.id,
                previous: '戻る',
                previousRouteName: 'orderDesc',
                showAccountControl: 'true'
            });
        }
    }
</script>

<style lang='scss'>
  .quote {
    ul {
      text-align: left;
      a, button {
        display: block;
        text-decoration: none;
        color: inherit;
        padding: 1.5em 0;
        margin-left: 1em;
        position: relative;
        border-bottom: 1px solid #ddd;
        width: 100%;
        text-align: left;
        .icon {
          font-size: 1.2em;
        }
        .icon-check {
          top: 1.35em;
          position: absolute;
          left: -1.5em;
          path {fill: #36f}
        }
        .icon-chevron-right {
          float: right;
          opacity: .5;
          margin-top: .15em;
          margin-right: .25em;
        }
      }
    }
  }
</style>